import { useState, ReactNode } from 'react';
import { ShareDialog } from './ShareDialog';

interface ShareProps {
  children: ReactNode;
  folder?: {
    id: number;
    name: string;
    reports?: any[];
  };
  report?: {
    id: string;
    name: string;
  };
}

export function Share({ children, folder, report }: ShareProps) {
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);

  return (
    <>
      <div onClick={handleOpen} className="cursor-pointer">
        {children}
      </div>

      <ShareDialog
        isOpen={isOpen}
        onClose={handleClose}
        folder={folder}
        report={report}
      />
    </>
  );
}